import { DataSource, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutScreenCodesQuickInfo extends Layout {
    panelScreenCodesQuickInfo: Panel;
    sourceScreenCodes: DataSource;
    textboxFieldCode: Textbox;
    textboxFieldCodeDesc: Textbox;
}
